import React from 'react';
import SEOHead from '../components/common/SEOHead';

export default function CookiesPolicy() {
  return (
    <>
      <SEOHead
        title="Cookies och lokal lagring | StartaWebb"
        description="Information om cookies, lokal lagring och teknisk cache på StartaWebb."
        canonical="https://startawebb.se/cookies-policy"
      />

      <article className="max-w-3xl mx-auto px-4 py-14 text-slate-700 leading-relaxed">
        <p className="text-blue-700 font-semibold mb-3">Senast uppdaterad 22 juli 2026</p>
        <h1 className="text-3xl md:text-4xl font-extrabold mb-6 text-slate-950">Cookies och lokal lagring</h1>
        <p className="mb-6">StartaWebb använder för närvarande inga annonseringscookies och aktiverar inte analys- eller spårningscookies på webbplatsen.</p>

        <h2 className="text-2xl font-bold mt-9 mb-3 text-slate-950">Tekniska funktioner</h2>
        <p>Webbläsaren kan använda teknisk cache för att ladda webbplatsens filer snabbare och göra sidan stabilare. Den används inte för att skapa en marknadsföringsprofil.</p>

        <h2 className="text-2xl font-bold mt-9 mb-3 text-slate-950">Externa länkar och formulär</h2>
        <p>Länkar till exempelvis Google Play och WhatsApp öppnar externa tjänster med egna regler. När du skickar kontaktformuläret behandlas uppgifterna av FormSubmit enligt beskrivningen i <a href="/integritetspolicy" className="text-blue-700 underline">integritetspolicyn</a>.</p>

        <h2 className="text-2xl font-bold mt-9 mb-3 text-slate-950">Om detta ändras</h2>
        <p>Om icke nödvändiga analys- eller marknadsföringstjänster införs ska informationen uppdateras och samtycke begäras när det krävs innan de aktiveras.</p>

        <h2 className="text-2xl font-bold mt-9 mb-3 text-slate-950">Kontakt</h2>
        <p>Frågor kan skickas till <a href="mailto:info@startawebb.se" className="text-blue-700 underline">info@startawebb.se</a>.</p>
      </article>
    </>
  );
}
